// Add-asset dialog classifier — splits the asset-type search results
// into two render buckets so the field-staff modal can prioritise the
// matches that look like what the user is typing.
//
//   - PRIMARY: the query is a case-insensitive prefix of at least
//     one whitespace- or hyphen-separated token in the name. Examples
//     for query "te": "**Te**nnis Court", "Air Curtain - **Te**lemetry",
//     "**Te**lephone System".
//   - SECONDARY: the query appears as a substring in the name but
//     does NOT prefix any token. Example for query "te":
//     "Was**te**water Pump", "Main**te**nance Hatch".
//
// The two buckets are mutually exclusive — a row is in primary OR
// secondary, never both. Rows whose name does not contain the query
// at all are dropped (the backend ILIKE filter already prevents that
// case post-name-only-search, so we stay defensive but expect the
// "neither" branch to be empty in practice).
//
// Empty / whitespace-only queries are treated as "no classification
// needed" — every row goes to `primary`, leaving `secondary` empty,
// so the dialog renders the existing groupBySystem layout unchanged.
//
// The actual classification logic lives in `lib/token-prefix-search.ts`
// — this file is the asset-type-shaped facade that has been the public
// API for the add-asset dialog since PR #458. It is also the public
// surface tested by `asset-search-classify.test.ts`.

import { classifyByTokenPrefix } from '../../lib/token-prefix-search'
import type { AssetTypeSearchRow } from '../../hooks/use-classification'

export interface ClassifiedRows {
  primary: AssetTypeSearchRow[]
  secondary: AssetTypeSearchRow[]
}

export function classifyByQuery(
  rows: readonly AssetTypeSearchRow[],
  query: string,
): ClassifiedRows {
  return classifyByTokenPrefix(rows, query, (row) => [row.name])
}
